import React from 'react';
import { motion } from 'framer-motion';
import ProductShowcase from '../components/ProductShowcase';
import { usePageTitle } from '../hooks/usePageTitle';

const ProductsPage: React.FC = () => {
  // 设置页面标题和描述
  usePageTitle(
    '产品展示',
    '提供多种工业炉及燃烧控制设备，满足客户不同产品、不同工况需求'
  );

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-primary">
        <div className="container-max text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              产品展示
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              提供多种工业炉及燃烧控制设备，满足客户不同产品、不同工况需求
            </p>
          </motion.div>
        </div>
      </section>

      <ProductShowcase showHeader={false} />
    </div>
  );
};

export default ProductsPage;
